import { Component, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-pdf-viewer',
    standalone: false,
    templateUrl: './pdf-viewer.component.html',
    styles: [`

    `]
  })
  export class CommonPdfViewerComponent implements OnInit, OnDestroy  {

  sourceFile: any;
  FileName: string;

    @Input()

    set SourceFile(source:any){
      this.sourceFile = source;
  }

  download(fileanme:string ) {

    this.FileName = fileanme;
  }
  get SourceFile(): any{
        return this.sourceFile;
    }

    constructor(){
      }

    ngOnInit(): void {
    }

    ngOnDestroy(){
    }
  }
